import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { OrganizationLeadTodoRuleEntityState } from '@_model/interfaces/organization-lead-todo-rule.model';

export interface OrganizationLeadTodoRuleState extends EntityState<OrganizationLeadTodoRuleEntityState> {
  isLoaded: boolean;
  isLoading: boolean;
  actives: number[];
}

export const adapter: EntityAdapter<OrganizationLeadTodoRuleEntityState> =
  createEntityAdapter<OrganizationLeadTodoRuleEntityState>({
    selectId: o => o.idOrganizationLeadTodoRule
  });
export const initialState: OrganizationLeadTodoRuleState = adapter.getInitialState({
  isLoaded: false,
  isLoading: false,
  actives: []
});

export const organizationLeadTodoRuleFeatureKey = 'organizationLeadTodoRule';
